// City "digital marketing" hub routes — the conversion-focused, full-service
// city page for each market. When a city has a dedicated `-digital-marketing`
// hub built (or the Colorado Springs HQ variant), it's listed here.
//
// This is the single source of truth for:
//   • The /service-areas grid (links to the strongest available page)
//   • A "Full digital marketing hub" CTA on /service-areas/{city} pages
//   • Any future component that needs to know "does this city have a hub yet?"
//
// When a city graduates from generic landing page → full digital marketing
// hub, add it here. The grid, CTAs, and downstream consumers pick it up
// automatically.
//
// IMPORTANT: keys MUST match a CityKey from `citiesData.ts`.

import type { CityKey } from "@/lib/citiesData";

export const CITY_HUB_ROUTES: Partial<Record<CityKey, string>> = {
  "colorado-springs": "/colorado-springs",
  monument: "/monument",
  "castle-rock": "/castle-rock-digital-marketing",
  parker: "/parker-digital-marketing",
  falcon: "/falcon",
  "woodland-park": "/woodland-park",
  fountain: "/fountain",
  denver: "/denver-digital-marketing",
  aurora: "/aurora-digital-marketing",
  boulder: "/boulder-digital-marketing",
  "fort-collins": "/fort-collins-digital-marketing",
  pueblo: "/pueblo-digital-marketing",
};

/** Returns the city's `-digital-marketing` hub URL when one exists. */
export function getCityHubRoute(slug: CityKey | string): string | undefined {
  return CITY_HUB_ROUTES[slug as CityKey];
}

/** True when the city has a dedicated digital marketing hub. */
export function hasCityHub(slug: CityKey | string): boolean {
  return Boolean(CITY_HUB_ROUTES[slug as CityKey]);
}
